import { inject } from '@angular/core';
import { of } from 'rxjs';
import { Interceptor, PromptResponse } from '@panaya/ai-chat/domain';
import { CanvasFrameStore } from './canvas-frame.store';
import { CanvasTurnTracker } from './canvas-turn.tracker';
import { CANVAS_CONTENT_CONTRIBUTOR, NO_CONTENT_CONTRIBUTOR } from './canvas-content-contributor';

/**
 * Runs on the last poll of a turn, which carries every command of the turn. A canvas this turn opened that got
 * neither a status nor content (for example the agent call was refused before it produced anything) closes again,
 * and the layout goes back to what it was.
 * A canvas an earlier turn opened is never closed here.
 */
export function createCanvasTurnEndInterceptor(): Interceptor<PromptResponse> {
    const store = inject(CanvasFrameStore);
    const tracker = inject(CanvasTurnTracker);
    const content = inject(CANVAS_CONTENT_CONTRIBUTOR, { optional: true }) ?? NO_CONTENT_CONTRIBUTOR;

    return (response: PromptResponse) => {
        if (store.isOpen() && tracker.openedThisTurn() && store.status() === null && !content.hasContent()) {
            // reset(), not close(): no create result exists, so nothing may show "Created".
            store.reset();
        }

        return of(response);
    };
}
